import { postRequest } from "./api";

// Login API
export const loginUser = async (credentials) => {
  return await postRequest("/user/user-login/", credentials);
};

// Signup API
export const registerUser = async (userData) => {
  return await postRequest("/auth/register/", userData);
};

// Logout API (optional)
export const logoutUser = async (credentials) => {
  return await postRequest("/user/user-login/", credentials);
};
